import { Injectable } from "@angular/core";
import { ThreadHelper } from "../../gyzmo-commons/helpers/thread.helper";
import { IDefaultDataDownloaderService } from "../../gyzmo-commons/interfaces/IDefaultDataDownloaderService";
import { IUserDto } from "../../gyzmo-commons/interfaces/IUserDto";
import { AppSqlProvider } from "../../gyzmo-commons/persistence/app.sql.provider";
import { LoggerService } from "../../gyzmo-commons/services/logs/logger.service";
import { AttachmentService } from "./attachment.service";
import { CustomisationService } from "./customisation.service";
import { DamageCategoryService } from "./inspection/common/damageCategory.service";
import { InspectionServiceV2 } from "./inspection/v2/inspection.service";
import { InspectionFacesServiceV2 } from "./inspection/v2/inspectionFaces.service";
import { TyreService } from "./tyre.service";

@Injectable({ providedIn: "root" })
export class DefaultDataDownloaderService extends IDefaultDataDownloaderService {
    constructor(private damageCategoryService: DamageCategoryService,
                private sqlProvider: AppSqlProvider,
                private customisationService: CustomisationService,
                private tyreService: TyreService,
                private logger: LoggerService,
                private inspectionServiceV2: InspectionServiceV2,
                private inspectionFacesServiceV2: InspectionFacesServiceV2,
                private attachmentService: AttachmentService) {
        super();
    }

    public syncDefaultDataNonBlocking() {
        setTimeout(async () => {
            let models = await this.inspectionServiceV2.getAllModels();
            this.sqlProvider.enableBulkWriting();
            for (const model of models) {
                await this.inspectionFacesServiceV2.synchronizeForModel(model);
                await ThreadHelper.sleep(1);
            }
            await this.sqlProvider.commitBulk();
            this.logger.info(this.constructor.name, "Non blocking sync finished.");
        }, 250);
    }

    public async checkDefaultData(): Promise<{ correctness: boolean; message: string }> {
        let correctness = await this.damageCategoryService.checkDamageCategoryData();
        if (!correctness) {
            return { correctness, message: "DamageCategories vide" };
        }

        correctness = await this.damageCategoryService.checkPossibleValuesData();
        if (!correctness) {
            return { correctness, message: "PossibleValues vide" };
        }

        return { correctness, message: "" };
    }

    public async onConnectionDefaultData(user: IUserDto): Promise<void> {
        let promises = [];

        this.sqlProvider.enableBulkWriting();
        promises.push(this.damageCategoryService.synchronize());
        promises.push(this.tyreService.synchronizeSizes());
        promises.push(this.tyreService.synchronizeBrands());
        promises.push(this.customisationService.synchronizeCustomisation(user.company.id));
        promises.push(this.attachmentService.cacheByCompanyId(user.company.id));
        promises.push(this.attachmentService.cacheByCompanyId("IRIUM"));
        promises.push(this.attachmentService.cacheDefaultPrivacyPolicy());
        promises.push(this.attachmentService.cacheDefaultCGU());
        promises.push(this.attachmentService.cacheDefaultUserManual());

        await Promise.all(promises);
        await this.sqlProvider.commitBulk();

        this.syncDefaultDataNonBlocking();
    }
}
